import { createSlice } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";
import { toastActions } from "@base-provider";

//generic action that handles form errors, shows a toast in each case and marks the form as submitted in order to red the fields
export const handleFormErrors = (payload) => (dispatch, getState) => {
  const t = payload.t;
  const formsToSubmit = payload.forms;
  if (payload.errors.some((x) => x.keyword === "required")) {
    dispatch(
      toastActions.showErrorMessage(
        t("components.formBuilder.messages.requiredFields")
      )
    );
  } else {
    dispatch(
      toastActions.showErrorMessage(
        t("components.formBuilder.messages.checkErrors")
      )
    );
  }
  if (formsToSubmit) {
    const { forms } = getState();
    formsToSubmit.forEach((name) => {
      const currentForm = forms.find((x) => x.name === name);
      if (currentForm) {
        //submit form in order to display the errors and style the fields with red border
        dispatch(formsActions.submit({ name, value: true }));
      }
    });
  }
};

const formsSlice = createSlice({
  name: "forms",
  initialState: [],
  reducers: {
    initialize(state, action) {
      let name = action.payload;
      let currentForm = state.find((form) => form.name === name);

      if (!name) return state;

      if (!currentForm) {
        return [
          ...state,
          {
            name,
            data: [],
            errors: [],
            hasChanges: false,
            submit: false,
          },
        ];
      }

      currentForm = {
        name,
        data: [],
        errors: [],
        hasChanges: false,
        submit: false,
      };
    },
    update(state, action) {
      let currentForm = state.find((form) => form.name === action.payload.name);

      if (!currentForm) return state;

      currentForm.data = action.payload.data;
      currentForm.errors = action.payload.errors;
      currentForm.hasChanges = action.payload.hasChanges;
    },
    delete(state, action) {
      return state.filter((form) => form.name !== action.payload);
    },
    submit(state, action) {
      let currentForm = state.find((form) => form.name === action.payload.name);

      if (!currentForm) return state;
      currentForm.submit = action.payload.value;
    },
  },
});

export const useFormsSelector = (names) => {
  return useSelector((state) => {
    if (Array.isArray(names)) {
      return state.forms.filter((form) => names.includes(form.name));
    } else {
      return state.forms.find((form) => form.name === names);
    }
  });
};

export const formsActions = formsSlice.actions;
export default formsSlice.reducer;
